import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { tap } from 'rxjs';
import { PreferenceApiService } from '../../services/api/preference.service';
import { FetchMode, GetUserPreferencesRequest, GetUserPreferencesResponse } from '../../models/dtos';
import { CommonDataService } from '../../services/common-data.service';
import { CONSTANTS } from '../../Constants/Constants';

export const preferenceResolver: ResolveFn<GetUserPreferencesResponse> = (route, state) => {
  
  const preferenceApiService = inject(PreferenceApiService);
  const commonDataService = inject(CommonDataService);

  const preferenceRequest: GetUserPreferencesRequest = {
    userId: '', 
    getPreferencesObject: FetchMode.Server,
    getFirePreferencesObject: FetchMode.Server,
    getESPreferencesObject: FetchMode.Server,
    getProposalPreferencesObject: FetchMode.Server,
    getCollaboratorPreferencesObject: true,
    getCostReviewerPreferencesObject: true,
    getTaxDetailsPreferencesObject: FetchMode.Server
  };

  return preferenceApiService.getPreference(preferenceRequest).pipe(
    tap((response) => {
      commonDataService.setCurrentApplicationCulture(response?.preferences?.cultureString ?? CONSTANTS.LANGUAGE_EN_US);
      commonDataService.setPreferenceData(response);
      commonDataService.setDecimalPrecision(response?.preferences?.decimalPrecision ?? CONSTANTS.TWO);
    })
  );
};